<template>
  <tree-list-layout
    :header-panel-enable="true"
    :left-panel-enable="leftPanelEnable"
    :left-panel-min-width="240"
    :left-panel-max-width="500"
    :right-top-panel-enable="rightTopPanelEnable"
    :speed-mode="speedMode"
  >
    <template #headerPanel></template>
    <template #leftPanel>
      <slot name="tree"></slot>
    </template>
    <template #rightTopPanel>
      <slot name="rightTop"></slot>
    </template>
    <template #rightMiddlePanel>
      <div class="right-middle-content-wrap" :style="rightMiddleStyle">
        <div ref="search">
          <slot name="search"></slot>
        </div>
        <div
          class="datatable-wrap"
          :style="`height:calc(100% - ${datatableWrapHeightOffset}px)`"
        >
          <!-- <div class="datatable-border"> -->
          <slot name="datatable"></slot>
          <!-- </div> -->
        </div>
      </div>
    </template>
  </tree-list-layout>
</template>

<script>
import TreeListLayout from "./TreeListLayout";

export default {
  name: "TreeListLayoutAdapter",
  components: {
    TreeListLayout
  },
  props: {
    leftPanelEnable: {
      type: Boolean,
      default: true
    },
    rightTopPanelEnable: {
      type: Boolean,
      default: true
    },
    // Animation behavior for heigh proformence
    speedMode: {
      type: Boolean,
      default: false
    },
    rightMiddleStyle: Object
  },
  data() {
    return {
      datatableWrapHeightOffset: 0,
      searchExist: true
    };
  },
  mounted() {
    if (!this.$refs.search || (this.$refs.search && this.$refs.search.offsetHeight === 0)) { this.searchExist = false; }
    this.resetDatatableWrapHeight();
    setInterval(this.resetDatatableWrapHeight, 300);
  },
  methods: {
    resetDatatableWrapHeight() {
      // Search height + Pager height
      if (this.$refs.search && this.searchExist) {
        this.datatableWrapHeightOffset = this.$refs.search.offsetHeight + 69;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.code {
  line-height: 40px;
  color: rgb(102 102 102);
}

.r-t-title .el-col {
  height: 100%;
}

.organization-r-b {
  width: 100%;
  padding: 24px;
  padding-bottom: 0;
  background: rgb(255 255 255);
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.organization-r-b .r-b-title {
  margin-bottom: 24px;
}

.datatable-list-cell {
}

.right_top_title {
}

.right_top_desc {
  line-height: 40px;
  padding-left: 14px;

  .right_top_info {
    margin-right: 24px;

    .context_label {
      font-size: 14px;
      font-weight: 400;
      color: rgb(33 37 46);
    }

    .context_info {
      font-size: 14px;
      font-weight: 400;
      color: rgb(80 83 99);
    }
  }
}

.searchArea .selectLable {
  font-size: 14px;
  line-height: 20px;
  padding-left: 14px;
  margin-top: 16px;
}

.searchArea .search {
  margin-top: 6px;
}

.bom,
.structure {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.organization-r-t {
  background: rgb(255, 255, 255);
  height: 106px;
  padding: 24px;
  border-bottom: 8px solid rgb(246 246 246);
}

.user_right_top {
  background: rgb(255, 255, 255);
  height: 202px;
  padding: 24px;
  border-bottom: 8px solid rgb(246, 246, 246);
}

.search {
  height: 60px;
}

.right-middle-content-wrap {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.datatable-wrap {
  height: calc(100% - 222px);
  background-color: rgb(255 255 255);
  box-sizing: border-box;
  border-left: 24px solid rgb(255 255 255);
  border-right: 24px solid rgb(255 255 255);

  .datatable-border {
    border: 1px solid rgb(212 217 226);
    border-bottom: 0;
    height: 100%;
    position: relative;
  }
}

::v-deep .custom__table {
  height: 100%;

  .table {
    height: 100%;

    .table-warp {
      height: 100%;
    }
  }
}
</style>
